export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  console.log("isAuthenticated called, token:", token ? "exists" : "null");
  if (!token) {
    console.log("No token found");
    return false;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    console.log("Token expiration:", payload.exp, "Current time:", currentTime);
    if (payload.exp < currentTime) {
      console.log("Token expired");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      return false;
    }
    console.log("Valid token found");
    return true;
  } catch (error) {
    console.error("Invalid token:", error.message);
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return false;
  }
};

export const isAdmin = () => {
  if (!isAuthenticated()) {
    console.log("isAdmin: User is not authenticated");
    return false;
  }

  const token = localStorage.getItem("token");
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const role = payload.role;
    console.log("isAdmin called, role from token:", role);
    const isAdminUser = role && role.toLowerCase() === "admin";
    console.log("isAdmin result:", isAdminUser);
    return isAdminUser;
  } catch (error) {
    console.error("isAdmin: Error decoding token:", error.message);
    return false;
  }
};

export const logout = () => {
  console.log("auth.js: Logging out");
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  console.log("auth.js: Token and role removed from localStorage");
};